import { useRegistrationStore } from '../../hooks';
import { ApiKeyTemplateRegistrationModalView } from '../../components/ApiKeyTemplateRegistrationModalView';

export const ApiKeyTemplateRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <ApiKeyTemplateRegistrationModalView {...registrationStore} />;
};
